export const ENROLLMENT_CONSTANTS = {
  ARGENTINA_CODE: 'AR',
  MN_TYPE_NAME: 'MN',
  DEFAULT_ISSUER: 'Ministerio de Salud de la Nación'
}; 